module.exports = {
    dialog: null,

    showLoading: function() {
        this.dialog = Odigeo.UIElements.loadingMyTripsDialog();
    },

    closeLoading: function() {
        this.dialog.remove();
    },

    showError: function() {
        this.dialog = Odigeo.UIElements.loadingMyTripsErrorDialog();
    },
};
